var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-skeleton-wrapper",
        {
          attrs: { loading: _vm.isLoading },
          scopedSlots: _vm._u([
            {
              key: "loading",
              fn: function() {
                return [
                  _c(
                    "div",
                    {
                      staticClass: "h-100 w-100 article-card position-relative",
                      class: {
                        overlay: _vm.isOverlayType
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "image-holder mb-2" },
                        [
                          _c("b-skeleton-img", {
                            staticClass: "w-100 h-100",
                            attrs: { "no-aspect": "", animation: "fade" }
                          }),
                          _vm._v(" "),
                          _vm.isOverlayType
                            ? _c(
                                "div",
                                { staticClass: "title-container w-100" },
                                [
                                  _c("b-skeleton", {
                                    staticClass: "w-100 parent-title"
                                  }),
                                  _vm._v(" "),
                                  _c("b-skeleton", {
                                    staticClass: "w-100 title mt-2"
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.isOverlayType
                        ? _c(
                            "div",
                            [
                              _c("b-skeleton", {
                                staticClass: "w-100 parent-title mt-3"
                              }),
                              _vm._v(" "),
                              _c("b-skeleton", {
                                staticClass: "w-100 title mt-2"
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _vm._v(" "),
          _vm.articleForCard !== null
            ? _c(
                "div",
                {
                  staticClass: "h-100 w-100 article-card position-relative",
                  class: {
                    overlay: _vm.isOverlayType
                  }
                },
                [
                  _vm.isLoggedIn && _vm.articleForCard.id !== null
                    ? _c("favorite-button", {
                        attrs: {
                          "item-id": parseInt(_vm.articleForCard.id),
                          "item-type": "article",
                          "is-background-visible": true
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: _vm.articleForCard.url,
                        target:
                          "target" in _vm.articleForCard
                            ? _vm.articleForCard.target
                            : "_self"
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "image-holder mb-2" },
                        [
                          _c("b-img-lazy", {
                            staticClass: "w-100",
                            attrs: {
                              src: _vm.articleForCard.imageSrc,
                              alt: _vm.articleForCard.title
                            }
                          }),
                          _vm._v(" "),
                          _vm.isOverlayType
                            ? _c("div", { staticClass: "title-container" }, [
                                _vm.articleForCard.parentTitle
                                  ? _c("div", {
                                      staticClass: "parent-title",
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm.articleForCard.parentTitle
                                        )
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "title mt-2",
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.articleForCard.title
                                    )
                                  }
                                })
                              ])
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.isOverlayType
                        ? _c("div", [
                            _vm.articleForCard.parentTitle
                              ? _c("div", {
                                  staticClass: "parent-title",
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.articleForCard.parentTitle
                                    )
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "title mt-2",
                              domProps: {
                                textContent: _vm._s(_vm.articleForCard.title)
                              }
                            })
                          ])
                        : _vm._e()
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }